
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { TooltipProvider } from '@/components/ui/tooltip';

interface NavigationSectionProps {
  title: string;
  emoji: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const NavigationSection = ({ 
  title, 
  emoji, 
  defaultOpen = false, 
  children 
}: NavigationSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="space-y-1">
      <CollapsibleTrigger asChild>
        <Button variant="ghost" className="w-full justify-between px-2 h-8">
          <span className="flex items-center text-sm font-medium text-muted-foreground">
            {emoji} {title}
          </span>
          {isOpen ? (
            <ChevronUp className="h-4 w-4 text-muted-foreground" />
          ) : (
            <ChevronDown className="h-4 w-4 text-muted-foreground" />
          )}
        </Button>
      </CollapsibleTrigger>
      
      <CollapsibleContent className="space-y-1">
        <TooltipProvider>
          {children}
        </TooltipProvider>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default NavigationSection;
